import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDealer } from "./useDealer";
import { useDealerUserInfo } from "../context/DealerUserInfoContext";
import { useDealers } from "src/context/DealersContext";

export const useValidateDealerId = () => {
  const navigate = useNavigate();
  const { dealer_id } = useDealer();
  const { dealerUserInfo } = useDealerUserInfo();
  const { dealerOptions } = useDealers();

  useEffect(() => {
    if (
      dealerUserInfo.is_admin ||
      !dealerOptions.length ||
      !dealer_id ||
      dealer_id === "finding-user-dealer"
    ) {
      return;
    }
    if (!dealerOptions.some((option) => option.dealer_id === dealer_id)) {
      console.warn(
        "Route dealer_id does not exist in dealerOptions:",
        "route:",
        dealer_id,
        "dealerOptions IDs:",
        dealerOptions.map((option) => option.dealer_id),
      );

      void navigate("/error", {
        state: { status: 403 },
        replace: true,
      });
    }
  }, [dealer_id, dealerOptions, navigate]);
};
